import { configureStore } from '@reduxjs/toolkit';

import authReducer from './reducers/authSlice';
import dataReducer from './reducers/dataSlice';
import themeReducer from './reducers/themeSlice';

export default configureStore({
    reducer: {
        auth: authReducer,
        data: dataReducer,
        theme: themeReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
    }),
})